import { MongoObservable } from "meteor-rxjs";

export const RawUpdates = new MongoObservable.Collection<any>("rawUpdates", { connection: null });
Meteor.startup(() => {

});



// WEBPACK FOOTER //
// ./src/api/server/collections/rawUpdates.ts